module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_innlandet_pos.e068b6de.pdf";